import { render, staticRenderFns } from "./multiLineLabel.vue?vue&type=template&id=ea8b5500"
import script from "./multiLineLabel.vue?vue&type=script&lang=js"
export * from "./multiLineLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports